// Components==============
import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button';
import RichText from 'components/UI/RichText';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router';
import './index.module.scss';
// =========================

const framerArrow = {
    open: {
        rotate: 180,
    },
    closed: {
        rotate: 0,
    },
};

const framerMenu = {
    open: {
        height: 'auto',

        transition: {
            delayChildren: 0.1,
            staggerChildren: 0.05,
        },
    },
    closed: {
        height: 0,
        transition: {
            duration: 0.5,
        },
    },
};

const framerMenuItem = {
    open: {
        opacity: 1,
    },
    closed: {
        opacity: 0,
        transition: {
            duration: 0.2,
        },
    },
};

export default function DropdownCard({
    employment,
    id,
    jobTitle,
    school,
    fte,
    startDate,
    availability,
    salaray,
    richText,
    location,
    button,
}) {
    const ref = useRef(null);
    const { pathname } = useLocation();
    const urlId = pathname?.split('/')?.[2];
    const isDropped = urlId === `${id}`;

    useEffect(() => {
        if (isDropped) {
            console.log(ref.current);
            window.scrollTo(0, ref.current.offsetTop);
        }
    }, [isDropped !== undefined]);

    const history = useHistory();

    let name = school?.name;
    if (school?.schoolGroup_id) {
        name = `Locatie ${school?.name}, ${school?.school_group?.name}`;
    }

    return (
        <motion.div
            initial="closed"
            animate={isDropped ? 'open' : 'closed'}
            styleName="container"
            ref={ref}
        >
            <div
                onClick={() =>
                    isDropped
                        ? history.push('/orion-vacatures')
                        : history.push(`/orion-vacatures/${id}`)
                }
                styleName="button"
            >
                <img src={school?.logo} alt={school?.name} />
                <div styleName="jobAndSchool">
                    <p styleName="jobTitle">
                        {jobTitle} | {fte}
                    </p>
                    <p styleName="school">{name}</p>
                </div>
                <div styleName="place">
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                    <p>{location || school?.contact?.city}</p>
                </div>
                <motion.button
                    variants={framerArrow}
                    type="button"
                    styleName="arrow"
                >
                    <FontAwesomeIcon icon={faAngleDown} />
                </motion.button>
            </div>
            <AnimatePresence>
                {isDropped && (
                    <motion.div
                        variants={framerMenu}
                        exit="closed"
                        initial="closed"
                        animate={isDropped ? 'open' : 'closed'}
                        styleName="menu"
                    >
                        <div styleName="innerMenu">
                            <motion.div
                                variants={framerMenuItem}
                                styleName="summary"
                            >
                                <div>
                                    <p>IngangsDatum:</p>
                                    <strong>{startDate || '-'}</strong>
                                </div>
                                <div>
                                    <p>Dienstverband:</p>
                                    <strong>
                                        {(employment === 'tijdelijk-uitzicht'
                                            ? 'tijdelijk met uitzicht op vast'
                                            : employment) || '-'}
                                    </strong>
                                </div>
                                <div>
                                    <p>Beschikbaarheid:</p>
                                    <strong>
                                        {availability
                                            ? availability === 'both'
                                                ? 'Fulltime/Parttime'
                                                : availability
                                            : '-'}
                                    </strong>
                                </div>
                                <div>
                                    <p>Fte:</p>
                                    <strong>{fte || '-'}</strong>
                                </div>
                                <div>
                                    <p>Salaris:</p>
                                    <strong>{salaray || '-'}</strong>
                                </div>
                            </motion.div>
                            <motion.div
                                variants={framerMenuItem}
                                styleName="content"
                            >
                                {school?.job_text ? (
                                    <div styleName="richText">
                                        <RichText
                                            richText={[
                                                {
                                                    layout: 'text',
                                                    attributes: {
                                                        text: school?.job_text,
                                                    },
                                                },
                                            ]}
                                        />
                                    </div>
                                ) : null}
                                <div styleName="richText">
                                    <RichText
                                        richText={[
                                            {
                                                layout: 'text',
                                                attributes: { text: richText },
                                            },
                                        ]}
                                    />
                                </div>
                                <a
                                    href={
                                        button?.link?.includes('@')
                                            ? `mailto:${button?.link}`
                                            : button?.link?.includes('http')
                                            ? button?.link
                                            : `https://${button?.link}`
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <Button>{button?.text}</Button>
                                </a>
                            </motion.div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
}
